import React from 'react'
import { CloseOne } from '@icon-park/react'
import { Button } from '@/components'
import { Tokens } from '@/assets/tokens'
import { ModalOverlay, ModalContainer, ModalHeader, ModalTitle, ModalContent } from './Modal.styles'

interface BaseModalProps {
  isOpen: boolean
  onClose: () => void
  title: string
  children: React.ReactNode
  maxWidth?: string
}

export function BaseModal({ isOpen, onClose, title, children, maxWidth }: BaseModalProps) {
  if (!isOpen) return null

  const handleOverlayClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose()
    }
  }

  return (
    <ModalOverlay onClick={handleOverlayClick}>
      <ModalContainer $maxWidth={maxWidth}>
        <ModalHeader>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <ModalTitle>{title}</ModalTitle>
            <Button.Root
              $variant="link"
              onClick={onClose}
              style={{
                minWidth: 'auto',
                width: '24px',
                height: '24px',
                padding: 0,
              }}>
              <Button.Icon value={CloseOne} color={Tokens.ColorTextSecondary} />
            </Button.Root>
          </div>
        </ModalHeader>
        <ModalContent>{children}</ModalContent>
      </ModalContainer>
    </ModalOverlay>
  )
}
